export default "__VITE_ASSET__DTsl7IwJ__"